import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { useSelector } from 'react-redux'

import Typography from '@material-ui/core/Typography'
import {
  getUrl,
} from 'utils/storage'

import ClickLink from './ClickLink'

import selectors from 'store/selectors'

const useStyles = makeStyles(theme => ({
  container: {
    
  },
  imageContainer: {
    margin: theme.spacing(0),
  },
  image: {
    maxWidth: '150px',
    width: '150px',
    border: '1px solid #000',
  },
  filepath: {
    marginTop: theme.spacing(2),
  }
}))

const isImage = (data) => {
  if(data.type.indexOf('image') == 0) return true
  if(data.filename.match(/\.{jpg,png,jpeg,gif}$/i)) return true
  return false
}

const UploadedFile = ({
  data,
  justImage = false,
  justLink = false,
}) => {
  const classes = useStyles()

  const activeProjectId = useSelector(selectors.user.activeProjectId)
  const token = useSelector(selectors.user.token)

  if(!data) return null
  
  return (
    <div className={ classes.container }>
      {
        data && isImage(data) && !justLink && (
          <div className={ classes.imageContainer }>
            <img className={ classes.image } src={ getUrl(activeProjectId, data.filepath, token) } />
          </div>
        )
      }
      {
        data && !justImage && (
          <div className={ classes.filepath }>
            <Typography variant="caption">
              <ClickLink
                onClick={() => {
                  window.open(getUrl(activeProjectId, data.filepath, token))
                }}
              >
                { data.filename }
              </ClickLink>
            </Typography>
          </div>
        )
      }
    </div>
  )
}

export default UploadedFile
